import { useAppSelector } from "store";
import styled from "@emotion/styled";
import { useQueryClient } from "@tanstack/react-query";
import { Button, Form, Input, message, Modal, Select, Spin } from "antd";
import React, { useState } from "react";
import UserSystemForm from "./UserSystemForm";
import { useCreateUserSystem } from "hooks/useAuth";

const { Option } = Select;

const ModalAddUser = () => {

  const queryClient = useQueryClient();

  const { mutate, isPending } = useCreateUserSystem();


  const [showModal, setShowModal] = useState<boolean>(false);

  const [formModal] = Form.useForm();

  const onCloseModal = () => {
    setShowModal(false);
  };

  const onFinishModal = (values: any) => {
    console.log(values);
    mutate({
        first_name: values.first_name,
        last_name: values.last_name,
        email: values.email,
        mobile: values.mobile,
        image: values.image && values.image.length > 0 ? values.image[0].url : "",
        role_id: values.role_id,
        is_generated_password: false,
        is_otp: true,
        address: {
            line_1: values.line_1,
            line_2: "",
            province_id: values.province,
            district_id: values.district,
            sub_district_id: values.sub_district,
            post_code: values.zip_code,
        }
    }, {
        onSuccess: async (data) => {
            if(!data.error_message) {
                await queryClient.refetchQueries({
                    queryKey: ["user_system"],
                    type: "active",
                  });
            onCloseModal();
            message.success("เพิ่มผู้ใช้งานระบบสำเร็จ");
        }else {
            message.error(`เพิ่มผู้ใช้งานระบบไม่สำเร็จ: ${data.error_message}`);
        }

        }
    })
  };

  return (
    <div>
      <Button
        type="primary"
        onClick={() => {
          setShowModal(true);
        }}
        disabled={isPending}
      >
        เพิ่มผู้ใช้งานระบบ
      </Button>
      <Modal
        title="เพิ่มผู้ใช้งานระบบ"
        open={showModal}
        maskClosable={false}
        onCancel={() => {
          onCloseModal();
        }}
        width={800}
        style={{ top: 20 }}
        footer={null}
      >
        <WrapperAll>
          <UserSystemForm form={formModal} onFinish={onFinishModal} isPending={isPending} />
        </WrapperAll>
      </Modal>
    </div>
  );
};

export default ModalAddUser;

const WrapperAll = styled.div`
  display: block;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 10px;
`;
